import { Plug } from "lucide-react";
import type { FpMessagePart } from "../../../../../schemas/codegen";
import { ExpandableMessageCard, SimpleMessageCard } from "./shared";

interface RuntimeLogsProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
}

/**
 * Placeholder for runtime logs.
 */
export function RuntimeLogs({ part }: RuntimeLogsProps) {
  const isError = part.status === "error";

  const activity =
    part.status === "pending"
      ? "Calling"
      : part.status === "complete"
        ? "Called"
        : "Failed:";
  const displayName = (
    <span className="inline-flex items-center gap-2">
      <span className="text-muted-foreground">{activity}</span>
      <span>{part.toolName}</span>
    </span>
  );

  if (isError) {
    return (
      <ExpandableMessageCard
        status={part.status}
        result={part.result}
        icon={Plug}
        title={displayName}
        accordionValue="runtime-logs"
      />
    );
  }

  return (
    <SimpleMessageCard status={part.status} icon={Plug} title={displayName} />
  );
}
